import axios from 'axios';
import { ApiResult } from './common';
import { UserType } from '../../../common/dist/common';

export interface ApiLoginResult {
  success: boolean;
  type: UserType;
  msg: string;
  isAccepted: boolean;
  name: string;
  email: string;
  nonce: string;
}

export const login = async (name: string, password: string): Promise<ApiResult<ApiLoginResult>> => {
  const ret = await axios.post('/api/auth/login', { name, password });
  if (ret.status !== 200) {
    return { result: false, expired: false, message: ret.statusText };
  }
  return ret.data as ApiResult<ApiLoginResult>;
};

export const check = async () => {
  const ret = await axios.get('/api/auth/login');
  if (ret.status !== 200) {
    return { result: false, expired: false, message: ret.statusText };
  }
  return ret.data as ApiResult<ApiLoginResult>;
};

export const logout = async () => {
  const ret = await axios.delete('/api/auth/login');
  if (ret.status !== 200) {
    return { result: false, expired: false, message: ret.statusText };
  }
  return ret.data as ApiResult<ApiLoginResult>;
};

export const accept = async () => {
  const ret = await axios.post('/api/auth/accept');
  return ret;
};

export const adminLogin = async (email: string, password: string) => {
  const ret = await axios.post('/api/auth/admin/login', { email, password });
  if (ret.status !== 200) {
    return { result: false, expired: false, message: ret.statusText };
  }
  return ret.data as ApiResult<ApiLoginResult>;
};
